import { Platform } from '@angular/cdk/platform';
import { Injectable, inject } from '@angular/core';
import { OneTrustService } from '@df/module-onetrust/onetrust.service';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
/**
 * Local decorator for OneTrustService
 * Skips OneTrust initialization when running in standalone PWA mode
 */
@Injectable({ providedIn: 'root' })
export class LocalOneTrustService extends OneTrustService {
    private pwaIntegrationService = inject(PwaIntegrationService);
    private platform = inject(Platform);
    override async appInitialize() {
        // Do not initialize OneTrust for ios, there is apple tracking transparency
        if (this.pwaIntegrationService?.isStandalone && this.platform.IOS) {
            return;
        }
        return super.appInitialize();
    }
}
